import { render } from "./RolesEditorProjectsArchive.vue?vue&type=template&id=10d81bb0"
import script from "./RolesEditorProjectsArchive.vue?vue&type=script&lang=js"
export * from "./RolesEditorProjectsArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__